import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import Home from './index';
import MobileHome from './MobileHome';

const ResponsiveHome = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileHome />}
      desktop={<Home />}
    />
  );
};

export default ResponsiveHome;